<ion-card *ngIf="(household$ | async) as household">
    <div class="overcard-title">
        MAANDELIJKSE KOSTEN
    </div>
    <ngx-circle-diagram
            *ngIf="household.total_cost"
            [totalCost]="numberToCurrency(household.total_cost)"
            [data]="getData(household)"
    ></ngx-circle-diagram>
</ion-card>
